// extracted by mini-css-extract-plugin
var _1 = "TablePaginationPageInput-moduledisabled__u0X23";
var _2 = "TablePaginationPageInput-moduleinput__LsGBW";
var _3 = "TablePaginationPageInput-moduletablePaginationPageInput__ZUq6W";
var _4 = "TablePaginationPageInput-moduletext__R1Bu1";
export { _1 as "disabled", _2 as "input", _3 as "tablePaginationPageInput", _4 as "text" }
